'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { ReservationStepsProps } from './reservation-form';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../ui/heading';

export function ReservationNavigation({
  steps,
  currentStep,
}: {
  steps: ReservationStepsProps[];
  currentStep: number;
}) {
  const currentStepObj = steps.find(step => step.id === currentStep)!;

  return (
    <div className="flex w-full flex-col items-center justify-center gap-8 sm:gap-6">
      <h1
        data-ea-visual-tag="h3"
        className="flex items-center gap-2 text-sm font-normal leading-[1.1] tracking-tight text-primary sm:text-base sm:leading-[1.1]"
      >
        <Image
          src="/images/star.svg"
          alt="Rezervácia"
          width={8.5}
          height={8}
          className="object-contain"
        />
        Rezervácia
      </h1>

      <div className={cn('grid w-full grid-cols-4 gap-2 sm:gap-3 md:gap-4 lg:gap-5 xl:gap-6')}>
        {steps.map(step => {
          const isActive = step.id <= currentStep;
          const isCurrent = step.id === currentStep;

          return (
            <div
              key={step.id}
              className="relative col-span-1 flex flex-col items-center justify-center gap-4 sm:gap-3"
            >
              <div
                className={cn(
                  'h-1 w-full overflow-hidden rounded-full',
                  isActive ? 'bg-primary' : 'bg-primary-foreground',
                )}
              />
              {isCurrent && (
                <p className="absolute left-1/2 top-3 -translate-x-1/2 whitespace-nowrap text-xs font-medium tracking-tight text-primary sm:text-sm">
                  Krok {step.id}/{steps.length}
                </p>
              )}
            </div>
          );
        })}
      </div>
      <Heading
        title={currentStepObj.label}
        className={{ container: 'mt-8 items-center justify-center text-center sm:mt-[30px]' }}
      />
    </div>
  );
}
